import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const Field = ({ label, required, children, hint, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-[13px] font-semibold text-navy">
      {label} {required && <span className="text-red-600">*</span>}
    </Label>
    {children}
    {hint && <p className="text-xs text-slate-500">{hint}</p>}
  </div>
);

export const SelectField = ({ value, onChange, options, placeholder = "Select", testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-11 bg-white" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const inputCls = "h-11 bg-white";
